import React, { useState } from 'react';

import DeleteIcon from '../../assets/icons/DeleteIcon';

import Modal from '../shared/modal';
import TextInput from '../shared/TextInput';
import ColorButton from '../shared/ColorButton';
import ColorSelect from '../shared/color-picker/ColorSelect';

const PipelineLabelsModal = ({ open, onClose, labels = [], onCreate, onUpdate, onDelete }) => {
  const [name, setName] = useState('');
  const [color, setColor] = useState('');
  const [loading, setLoading] = useState(false);

  const onAddClick = async () => {
    try {
      setLoading(true);
      await onCreate(name, color);
      setName('');
      setColor('');
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Edit Labels'
      className='edit-labels-modal__container'
    >
      <div className='edit-labels-modal__content'>
        <div>
          <div>
            <div className='secondary m-b-sm'>Label Name</div>
            <TextInput
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder='Type name here'
            />
          </div>

          <div className='m-t-md'>
            <div className='secondary m-b-sm'>Label Color</div>

            <ColorSelect
              value={color}
              onChange={(value) => setColor(value)}
              placeholder='Pick label color'
            />
          </div>

          <div className='d-flex flex-end m-t-lg'>
            <ColorButton
              color='blue'
              text='Add'
              onClick={onAddClick}
              disabled={loading || !name || !color}
              loading={loading}
            />
          </div>
        </div>

        <div className='edit-labels-modal__labels-container'>
          {labels?.length ? (
            labels.map((label) => (
              <div key={label.id} className='d-flex space-between'>
                <div className='d-flex'>
                  <div style={{ height: 20, width: 20, borderRadius: 4, backgroundColor: label.color }} />
                  <div className='m-l-md'>{label.name}</div>
                </div>
                <div className='pointer'>
                  <DeleteIcon color="#F53434" fontSize='small' onClick={() => onDelete(label.id)} />
                </div>
              </div>
            ))
          ) : (
            <div className='text-center p-lg font-bold secondary'>
              No Labels
            </div>
          )}
        </div>

        <div className='d-flex flex-end m-t-lg'>
          <ColorButton
            color='blue'
            text='Done'
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  )
};

export default PipelineLabelsModal;
